"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'LotDetailGestMens',
  props: ['idLot'],
  data: function data() {
    return {
      refresh: 0,
      lotsDetail: [],
      gestmensLotDetail: [],
      calculs: [],
      totaux: [],
      modeEdit: false,
      modeEditCounter: 0,
      rowsForCanceling: [],
      rowsForSaving: [],
      // pour mémoriser uniquement les lignes modifiées et éviter de tout sauvegarder
      CONST: CONST,
      formData: [],
      YYYYMM: '',
      YYYYMMmoins1: '',
      YYYYMMmoins2: ''
    };
  },
  computed: {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    }
  },
  created: function created() {
    var _this = this;

    this.$watch('$root.modeEdit', function (newValue) {
      if (newValue === false) {
        _this.modeEdit = false;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    _eventBus.EventBus.$on('EDIT_LOT', function (idLot) {
      if (_this2.idLot === idLot) {
        _this2.modeEdit = true;
        _this2.rowsForCanceling = JSON.parse(JSON.stringify(_this2.gestmensLotDetail));
        _this2.rowsForSaving = [];

        _eventBus.EventBus.$emit('MODE_EDIT', true);
      }
    });

    _eventBus.EventBus.$on('REFRESH', function () {
      var typeLigne = [CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT_MARCHE_PRINCIPAL, CONST.LOT_DETAIL.TYPE_LIGNE.TRANSFERT, CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION, CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE];
      _this2.lotsDetail = _this2.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.gestmensLotDetail = _this2.$store.getters.affaire.gestmensLotDetail.filter(function (x) {
        return x.id_lot === _this2.idLot;
      });
      _this2.calculs = _this2.$store.getters.affaire.calculs.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.totaux = _this2.$store.getters.affaire.calculs.lots.filter(function (x) {
        return x.id === _this2.idLot;
      });
      _this2.formData = _this2.calculs; // période de gestion mensuelle

      _this2.YYYYMM = _this2.$store.getters.affaire.YYYYMM ? (0, _moment.default)(_this2.$store.getters.affaire.YYYYMM, 'YYYYMM').format('MM/YYYY') : '';
      _this2.YYYYMMmoins1 = _this2.$store.getters.affaire.YYYYMMmoins1 ? (0, _moment.default)(_this2.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM').format('MM/YYYY') : '';
      _this2.YYYYMMmoins2 = _this2.$store.getters.affaire.YYYYMMmoins2 ? (0, _moment.default)(_this2.$store.getters.affaire.YYYYMMmoins2, 'YYYYMM').format('MM/YYYY') : '';
    });

    this.refresh++; // --
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('EDIT_LOT');

    _eventBus.EventBus.$off('REFRESH');
  },
  methods: {
    canEdit: function canEdit() {
      // edition possible uniquement si on est sur la période de gestion courante.
      return this.affaire.YYYYMM === this.affaire.currentGestMensYYYYMM;
    },
    canAddData: function canAddData(scope) {
      var typeLigne = [CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT, CONST.LOT_DETAIL.TYPE_LIGNE.TRANSFERT, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT_MARCHE_PRINCIPAL // CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE
      ];
      var cond1 = scope.row.validation === 1 && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE;
      var cond2 = scope.row.validation === 1 && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE;
      var cond3 = typeLigne.includes(scope.row.type_lot_detail);
      return cond1 || cond2 || cond3; // return (scope.row.validation === 1 && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE) || typeLigne.includes(scope.row.type_lot_detail)
    },
    handleInput: function handleInput(scope, action) {
      var _this3 = this;

      // mémorisation de la ligne modifiée pour ne sauvegarder + tard que celles concernées
      // et pas toutes les lignes de lotsDetail (on optimise le nombre de requete sql à faire)
      if (this.rowsForSaving.indexOf(scope.$index) === -1) {
        this.rowsForSaving.push(scope.$index);
      }

      var row = this.$store.getters.affaire.gestmensLotDetail.filter(function (x) {
        return x.id_lot_detail === scope.row.id && x.anneemois === _this3.affaire.YYYYMM;
      })[0];
      var data = {
        id: row ? row.id : null,
        id_lot: this.idLot,
        id_affaire: this.affaire.affaire.id,
        id_lot_detail: scope.row.id,
        anneemois: this.affaire.YYYYMM,
        pc_avancement_cumule: this.calculs[scope.$index].pcAvancementCumule,
        mt_facture: this.calculs[scope.$index].mtFacture
      };
      this.$store.dispatch('affaire/setGestMensLotDetail', data).then(function () {
        if (action === 'refresh_calcul') {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');
        }
      });
    },
    handleCancel: function handleCancel() {
      var _this4 = this;

      // pour vider les champ de saisie et ne pas avoir l'ancienne valeur
      this.lotsDetail.forEach(function (row) {
        row.pc_avancement_cumule = '';
        row.mt_facture = '';
      }); // traitement de l'annulation

      this.modeEdit = false;
      this.$store.dispatch('affaire/cancelGestMensLotDetail').then(function () {
        var rows = _this4.rowsForCanceling;
        rows.forEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(row, index) {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this4.$store.dispatch('affaire/setGestMensLotDetail', row);

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
        _this4.rowsForCanceling = [];
        _this4.rowsForSaving = [];

        _eventBus.EventBus.$emit('REFRESH_CALCULS');

        _eventBus.EventBus.$emit('MODE_EDIT', false);
      });
    },
    handleSave: function handleSave() {
      var _this5 = this;

      var pcNoValid = this.calculs.filter(function (x) {
        return x.pcAvancementCumule > 100;
      });

      if (pcNoValid && pcNoValid.length > 0) {
        this.$alert('Données saisies non valides', 'Enregistrement impossible', {
          confirmButtonText: 'Annuler',
          type: 'error'
        });
      } else {
        this.modeEdit = false;
        var rows = this.rowsForSaving;
        rows.forEach( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(index) {
            var updLotDetail, data, row;
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(_this5.calculs[index].prestataire !== _this5.lotsDetail[index].prestataire)) {
                      _context2.next = 7;
                      break;
                    }

                    // maj du store
                    _this5.lotsDetail[index].prestataire = _this5.calculs[index].prestataire;
                    _context2.next = 4;
                    return _this5.$store.dispatch('affaire/setLotDetail', _this5.lotsDetail);

                  case 4:
                    // maj en BdD
                    updLotDetail = {
                      id: _this5.calculs[index].id,
                      prestataire: _this5.calculs[index].prestataire
                    };
                    _context2.next = 7;
                    return _this5.$store.dispatch('affaire/updateLotDetail', updLotDetail);

                  case 7:
                    // --
                    // enregistrement des % et montants
                    data = {
                      id_lot_detail: _this5.calculs[index].id,
                      anneemois: _this5.affaire.YYYYMM,
                      pc_avancement_cumule: isNaN(_this5.calculs[index].pcAvancementCumule) || _this5.calculs[index].pcAvancementCumule === '' ? 0 : _this5.calculs[index].pcAvancementCumule,
                      // this.calculs[index].pcAvancementCumule,
                      mt_facture: isNaN(_this5.calculs[index].mtFacture) || _this5.calculs[index].mtFacture === '' ? 0 : _this5.calculs[index].mtFacture
                    };
                    row = _this5.gestmensLotDetail.filter(function (x) {
                      return x.id_lot_detail === _this5.calculs[index].id && x.anneemois === _this5.affaire.YYYYMM;
                    })[0];

                    if (!(row && row.id !== null)) {
                      _context2.next = 15;
                      break;
                    }

                    // mise à jour de la ligne identifiée par l'id dans la table gestmens_lotdetail
                    data.id = row.id;
                    _context2.next = 13;
                    return _this5.$store.dispatch('affaire/updateGestMensLotDetail', data);

                  case 13:
                    _context2.next = 17;
                    break;

                  case 15:
                    _context2.next = 17;
                    return _this5.$store.dispatch('affaire/insertGestMensLotDetail', data);

                  case 17:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x3) {
            return _ref2.apply(this, arguments);
          };
        }());

        _eventBus.EventBus.$emit('REFRESH_CALCULS');

        _eventBus.EventBus.$emit('MODE_EDIT', false);
      }
    },
    cellClassName: function cellClassName(_ref3) {
      var columnIndex = _ref3.columnIndex;

      if (columnIndex >= 11 && columnIndex <= 13) {
        return 'tb-pattern';
      }
    }
  }
};
exports.default = _default;